import { render, staticRenderFns } from "./VideoJS.vue?vue&type=template&id=5f13ba18&scoped=true"
import script from "./VideoJS.vue?vue&type=script&lang=js"
export * from "./VideoJS.vue?vue&type=script&lang=js"
import style0 from "./VideoJS.vue?vue&type=style&index=0&id=5f13ba18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13ba18",
  null
  
)

export default component.exports